/* src/app/shared-module/components/image-preview/image-preview.component.scss */
:host {
  display: block;
}
.ip-dialog-wrap {
  position: relative;
  width: 100vw;
  height: 100vh;
  background: rgba(8, 10, 14, 0.95);
  overflow: hidden;
}
.ip-close-btn {
  position: absolute;
  top: 14px;
  margin-top: 20px;
  right: 16px;
  z-index: 3;
  width: 40px;
  height: 40px;
  border: 0;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.14);
  color: #fff;
  font-size: 20px;
  display: grid;
  place-items: center;
}
.ip-toolbar {
  position: absolute;
  left: 50%;
  bottom: 22px;
  z-index: 3;
  transform: translateX(-50%);
  display: flex;
  gap: 10px;
  padding: 10px;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.14);
  -webkit-backdrop-filter: blur(6px);
  backdrop-filter: blur(6px);
}
.ip-tool-btn {
  min-width: 56px;
  height: 38px;
  border: 0;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.2);
  color: #fff;
  font-weight: 600;
}
.ip-image-stage {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  touch-action: none;
}
.ip-image {
  max-width: 92vw;
  max-height: 88vh;
  object-fit: contain;
  transition: transform 0.18s ease;
  transform-origin: center center;
  -webkit-user-select: none;
  user-select: none;
  -webkit-user-drag: none;
}
/*# sourceMappingURL=image-preview.component.css.map */
